import { render, staticRenderFns } from "./VerAlertaVehiculoModal.vue?vue&type=template&id=18afc0cd&scoped=true&"
import script from "./VerAlertaVehiculoModal.vue?vue&type=script&lang=ts&"
export * from "./VerAlertaVehiculoModal.vue?vue&type=script&lang=ts&"
import style0 from "./VerAlertaVehiculoModal.vue?vue&type=style&index=0&id=18afc0cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18afc0cd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('18afc0cd', component.options)
    } else {
      api.reload('18afc0cd', component.options)
    }
    module.hot.accept("./VerAlertaVehiculoModal.vue?vue&type=template&id=18afc0cd&scoped=true&", function () {
      api.rerender('18afc0cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Alertas/VerAlertaVehiculoModal.vue"
export default component.exports